import React from 'react';

import { TextArea } from '@ui-library';

import { instructionsCounter, instructionsTooLong } from '../../utils/stackPicker';

interface InstructionsFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  /** The cap on their length, from GET /projects/stacks or the instructions API. */
  maxChars: number;
  /** The line under the field while the text is within the cap. */
  hint: string;
  disabled?: boolean;
}

/** The custom instructions box of the Create Project, Clone and Edit project
 *  drawers, under the name users know them by: its counter counts as the
 *  platform does, and over the cap the line under it says so in the platform's
 *  words. */
export const InstructionsField: React.FC<InstructionsFieldProps> = ({ id, value, onChange, maxChars, hint, disabled }) => (
  <TextArea
    id={id}
    name={id}
    label="Special Instructions"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    rows={6}
    helperText={hint}
    errorText={instructionsTooLong(value, maxChars) ?? undefined}
    counter={instructionsCounter(value, maxChars)}
    disabled={disabled}
  />
);
